import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { set_mouseoversidebar_data } from '../../../core/data/redux/action';
import { adminSidebar } from '../../../core/data/json/admin_sidebar_data';
import { AppState, SideBarData } from '../../../core/models/interface';

const Sidebar = () => {
  const toggle_data = useSelector((state: AppState) => state.mouseOverSidebar);
  const dispatch = useDispatch();

  const [sidebarData, setSidebarData] = useState(adminSidebar);
  const normalizePath = (path: string) => {
    if (!path) {
      return '';
    }
    return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  };
  const isRouteActive = (route?: string) => {
    if (!route) {
      return false;
    }
    const currentPath = normalizePath(Location.pathname);
    const targetPath = normalizePath(route);
    return (
      currentPath === targetPath ||
      currentPath.startsWith(`${targetPath}/`)
    );
  };
  const toogle = () => {
    dispatch(set_mouseoversidebar_data(toggle_data ? false : true));
  };
  const Location = useLocation();
  const activeRouterPath = (route?: string) => {
    return isRouteActive(route);
  };
  const activeRouterMenu = (menu: SideBarData) => {
    if (menu.hasSubRoute && menu.subMenus?.length) {
      return menu.subMenus.some((subMenu) => isRouteActive(subMenu.route));
    }
    return isRouteActive(menu.route);
  };
  const expandSubMenus = (menu: SideBarData) => {
    if (menu.showSubRoute) {
      sessionStorage.removeItem('menuValue');
    } else {
      sessionStorage.setItem('menuValue', menu.menuValue);
    }
    const updatedAdminSidebar = sidebarData.map((section) => {
      const updatedSection = { ...section };
      updatedSection.menu = section.menu.map((menuItem) =>
        menu.menuValue != menuItem.menuValue
          ? {
              ...menuItem,
              showSubRoute: false,
            }
          : {
              ...menuItem,
              showSubRoute: !menuItem.showSubRoute,
            },
      );
      return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  useEffect(() => {
    setSidebarData((prevSidebar) =>
      prevSidebar.map((section) => ({
        ...section,
        menu: section.menu.map((menuItem) => {
          if (!menuItem.hasSubRoute || !menuItem.subMenus?.length) {
            return menuItem;
          }
          const shouldExpand = menuItem.subMenus.some((subMenu) =>
            isRouteActive(subMenu.route),
          );
          if (!shouldExpand) {
            return menuItem;
          }
          return {
            ...menuItem,
            showSubRoute: true,
          };
        }),
      })),
    );
  }, [Location.pathname]);
  
  return (
    <div
      className="admin-sidebar"
      id="sidebar"
      onMouseEnter={toogle}
      onMouseLeave={toogle}
    >
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-logo">
          <Link to="/" style={{textDecoration: 'none', color: 'white'}}>
            <h3>Manage</h3>
          </Link>
        </div>
        {/* <div className="admin-siderbar-toggle">
          <Link to={'#'} onClick={toggle}>
            <label className="switch" id="toggle_btn">
              <input type="checkbox" />
              <span className="admin-slider round" />
            </label>
          </Link>
        </div> */}
      </div>
      <div className="admin-sidebar-inner slimscroll">
        <Scrollbars>
          <div id="sidebar-menu" className="admin-sidebar-menu">
            <ul>
              {sidebarData.map((mainTittle: any, index: any) => {
                // if(userRole !== 'super_admin' ){
                //   if(mainTittle.tittle === 'Admin' || mainTittle.tittle === 'Finans' || mainTittle.tittle === 'Ana Sayfa' ){
                //   return null;
                // }
                // }

                return (
                  <React.Fragment key={`sidebar-section-${index}`}>
                    <li className="menu-title">
                      <h6>{mainTittle.tittle}</h6>
                    </li>
                    {mainTittle.menu.map(
                      (menu: SideBarData) => {
                        // if(userRole !== 'super_admin' && menu.menuValue === 'İstatistikler'){
                        //   return null;
                        // }
                        
                          return (
                            <>
                              {menu.hasSubRoute === false ? (
                              <li key={`${mainTittle.tittle}-${menu.menuValue}`}>
                                <Link
                                  to={menu.route}
                                  className={`${
                                    activeRouterPath(menu.route) ? 'active' : ''
                                  }`}
                                  style={{textDecoration: 'none'}}
                                >
                                  {menu.icon} <span>{menu.menuValue}</span>
                                </Link>
                              </li>
                            ) : (
                              <li
                                className={`submenu ${
                                  activeRouterMenu(menu) ? 'active' : ''
                                }`}
                                key={`${mainTittle.tittle}-${menu.menuValue}`}
                              >
                                <Link
                                  to="#"
                                  onClick={() => expandSubMenus(menu)}
                                  className={`${
                                    menu.showSubRoute ? 'subdrop' : ''
                                  } ${
                                    activeRouterMenu(menu)
                                      ? 'active'
                                      : ''
                                  }`}
                                >
                                  {menu.icon}
                                  <span>{menu.menuValue}</span>
                                  <span className="menu-arrow">
                                    {menu.showSubRoute ? (
                                      <Icon.ChevronDown className="react-feather-custom"></Icon.ChevronDown>
                                    ) : (
                                      <Icon.ChevronRight className="react-feather-custom"></Icon.ChevronRight>
                                    )}
                                  </span>
                                </Link>
                                <ul
                                  style={{
                                    display: menu.showSubRoute
                                      ? 'block'
                                      : 'none',
                                  }}
                                >
                                  {menu.subMenus.map(
                                    (subMenus: any, subMenu: number) => {
                                      return (
                                          <li key={`${menu.menuValue}-${subMenu}`}>
                                            <Link
                                              to={subMenus.route}
                                              className={`${
                                                activeRouterPath(subMenus.route)
                                                  ? 'active'
                                                  : ''
                                              }`}
                                            >
                                              {subMenus.menuValue}
                                            </Link>
                                          </li>
                                      );
                                    },
                                  )}
                                </ul>
                              </li>
                            )}
                          </>
                        );
                      },
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default Sidebar;
